import { Button, Icon, Popup, Dropdown, DropdownMenu, Segment, DropdownItem, Divider } from "semantic-ui-react"
import { severity_color } from "../IconMatrix"
import { useState } from "react"
import api from '../../../apis/api';
import { epochToDateString } from "../../EpochToString";

const AssetAlert = ({ alerts, callback }) => {

    const [open, setOpen] = useState(false)
    
    const sevs = alerts.map(i => i.severity)
    const sev = Math.min(...sevs)

    function reset(id){
        api.put('/alerts/reset', {}, {params: {id: id}}).then(r => {
            callback()
        })
    }

    return <Popup on='click' open={open} onClose={() => setOpen(false)} trigger={<Icon title={`${alerts.length} Alerts `} name="exclamation triangle" onClick={() => setOpen(true)} color={severity_color[sev]} />}>
        <Popup.Content>
            {alerts.slice(0,5).map(alert => (
                <Segment>
                    <div style={{display: "flex"}}>
                        <div style={{flexGrow: 1}}>
                        <b> <Icon title={`Severity ${alert.severity}`} name="exclamation triangle" color={severity_color[alert.severity]} /> {epochToDateString(alert.datetime)}</b>
                        <Dropdown item icon="triangle right">
                            <DropdownMenu>
                                <DropdownItem text="Reset" onClick={() => reset(alert.id)}/>

                            </DropdownMenu>
                        </Dropdown>
                        </div>
                        <div style={{textAlign: "right"}}>
                        {alert.ticketNumber?
                            <a style={{cursor: "pointer"}} onClick={() => window.open(`/tickets/details/${alert.ticketNumber}`, "_blank")}>{alert.ticketNumber}</a>
                        :null}
                        </div>
                    </div>

                    <Divider />
                    <div>{alert.message.length > 100?alert.message.slice(0, 100) + "...": alert.message}</div>
                </Segment>
            ))}
        </Popup.Content>
    </Popup>


}

export default AssetAlert